<div class="content__inner">
    <header class="content__title">
        <h1 *ngIf="MODE === 'ADD'">{{ "salesmanagershopitems.detail.add.title" | translate }}</h1>
        <h1 *ngIf="MODE === 'EDIT'">{{ "salesmanagershopitems.detail.edit.title" | translate }}</h1>

        <div class="actions">
            <button (click)="back()" class="btn btn-secondary btn--icon-text"><i class="zmdi zmdi-arrow-back"></i> {{ "global.buttons.back" | translate }}</button>
        </div>
    </header>

    <div class="card">
        <div class="card-body">
            <form name="form" class="row" *ngIf="salesManagerShopItem" (ngSubmit)="f.form.valid && save()" #f="ngForm" novalidate>
                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ "salesmanagershopitems.props.name" | translate }}</label>
                        <input name="name" type="text" class="form-control" [(ngModel)]="salesManagerShopItem.name" #name="ngModel" [ngClass]="{ 'is-invalid': f.submitted && name.invalid }" required />
                        <i class="form-group__bar"></i>
                        <div class="invalid-tooltip">
                            {{ "salesmanagershopitems.detail.validation.name" | translate }}
                        </div>
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ "salesmanagershopitems.props.materialnumber" | translate }}</label>
                        <input
                            name="materialNumber"
                            type="text"
                            class="form-control"
                            [(ngModel)]="salesManagerShopItem.materialNumber"
                            #materialNumber="ngModel"
                            [ngClass]="{ 'is-invalid': f.submitted && materialNumber.invalid }"
                            required
                        />
                        <i class="form-group__bar"></i>
                        <div class="invalid-tooltip">
                            {{ "salesmanagershopitems.detail.validation.materialnumber" | translate }}
                        </div>
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ "salesmanagershopitems.props.category" | translate }}</label>
                        <ng-select
                            name="category"
                            [(ngModel)]="salesManagerShopItem.category"
                            #category="ngModel"
                            [ngClass]="{ 'is-invalid': f.submitted && !salesManagerShopItem.category }"
                            [items]="categories"
                            bindLabel="label"
                            bindValue="value"
                            [placeholder]="'salesmanagershopitems.detail.edit.category.placeholder' | translate"
                        >
                        </ng-select>
                        <i class="form-group__bar"></i>
                        <div class="invalid-tooltip">
                            {{ "salesmanagershopitems.detail.validation.category" | translate }}
                        </div>
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ "salesmanagershopitems.props.maximumOrder" | translate }}</label>
                        <input name="maximumOrder" type="number" class="form-control" [(ngModel)]="salesManagerShopItem.maximumOrder" #maximumOrder="ngModel" [ngClass]="{ 'is-invalid': f.submitted && maximumOrder.invalid }" />
                        <i class="form-group__bar"></i>
                        <div class="invalid-tooltip">
                            {{ "salesmanagershopitems.detail.validation.maximumOrder" | translate }}
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-group">
                        <div class="checkbox">
                            <input type="checkbox" [(ngModel)]="salesManagerShopItem.inactive" id="inactive" name="inactive" />
                            <label class="checkbox__label" for="inactive">{{ "salesmanagershopitems.props.inactive" | translate }}</label>
                        </div>
                    </div>
                </div>

                <div class="col-md-12">
                    <button class="float-right btn btn-success btn--icon-text" [disabled]="f.submitted && f.invalid"><i class="zmdi zmdi-check"></i> {{ "global.buttons.save" | translate }}</button>
                </div>
            </form>
        </div>
    </div>
</div>
